import { render, staticRenderFns } from "./ActionRecommendRequest.vue?vue&type=template&id=cbda3878&"
import script from "./ActionRecommendRequest.vue?vue&type=script&lang=js&"
export * from "./ActionRecommendRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports